module.exports = __webpack_public_path__ + "img/haarlem_shop_map.a6bacfd1.svg";